<template>
  <div
    class="o-flex -alignCenter -gap2 c-chat__usersListItem u-padding1"
    :class="{
      '-active': chatStore.chatThread?.azure_chat_thread_id === user.azure_chat_thread_id,
      '-unread': hasUnreadMessages,
    }"
    v-on="{ ...$listeners }">
    <UserAvatar
      :user="user"
      medium
      class="o-flex__item -noShrink" />
    <div class="o-flex__item -grow c-chat__usersListItemRight">
      <div class="o-flex -spaceBetween -alignCenter -fullWidth u-marginRight1">
        <div
          class="t-caption1"
          v-html="user.displayName" />
        <div>
          <span
            v-if="lastMessageTime"
            class="t-caption2">{{ lastMessageTime }}</span>
        </div>
      </div>
      <UserLastMessage :message="message" />
    </div>
  </div>
</template>

<script setup>
import { isToday, format, formatDistanceToNow } from 'date-fns'
import { computed } from 'vue'

import api from '@/logic/api'
import { useChatStore } from '@/modules/chat/chatStore'
import UserAvatar from '@/modules/chat/components/DialogSidebar/UserAvatar.vue'
import UserLastMessage from '@/modules/chat/components/DialogSidebar/UserLastMessage.vue'
import { dateFnsLocaleMap } from '@/utils/dateFnsLocales'

const props = defineProps({
  user: {
    type: Object,
    required: true,
  },
  hasUnreadMessages: {
    type: Boolean,
    required: false,
    default: false,
  },
  message: {
    type: Object,
    required: false,
    default: () => {
      return {
        text: '',
        time: '',
      }
    },
  },
})

const chatStore = useChatStore()
const lastMessageTime = computed(() => {
  if (!props.message?.created_at) {
    return ''
  }
  const messageDate = new Date(props.message.created_at)
  const locale = api.i18n.locale
  const dateFnsLocale = dateFnsLocaleMap[locale] || dateFnsLocaleMap.en

  if (isToday(messageDate)) {
    return format(messageDate, 'HH:mm')
  }
  return formatDistanceToNow(messageDate, { addSuffix: true, locale: dateFnsLocale })
})
</script>
